export const extensionConstants = {
    GET_OAUTH_INITIATE_SUCCESS: 'GET_OAUTH_INITIATE_SUCCESS',
    GET_MAGENTO_TOKEN_SUCCESS: 'GET_MAGENTO_TOKEN_SUCCESS'
    
 };
 